import { RootState } from "../../interfaces/RootState";

export function selectNextError(state: RootState): string {
    return state.hydrolink.error.errors[0] ? state.hydrolink.error.errors[0].message : "";
}
